export default __webpack_public_path__ + "static/media/photo--lg--christina-4.39ec5a62.jpg";